/* lp-bundle-buy — bundle buy panel beside a video-first gallery (standard §6).
   State: the active pack (island index) and one picked value per option row. A variant is resolved when every
   row is picked; price and stock follow. Rows are an accordion: one open at a time, a sized row collapses to
   "name · size · Change", the next unsized row opens itself. The gallery's first slide is the clip (muted, paused off screen); the pack's photos follow.
   The clip has inline play / pause, mute and full-screen controls (a tap on the picture toggles play). Full screen opens
   the viewer, sized to the video's own aspect ratio (<dialog>, sound on, progress, mute, play / pause, Escape or the backdrop
   closes; the inline clip resumes muted). Cart add: /cart/add.js with Impact's bundled sections, then variant:add / cart:change / lp:cart-add. Works without
   GSAP; with it (LP.gsap, motion allowed) the row bodies fold open and closed.
   Pack tiers: a pack with Discount Kit volume tiers ("2:15,3:20") gets 1 / 2 / 3-pair tier rows instead of the stepper;
   the tier sets the quantity, the price shows the tier total with the full price struck through (display only).
   Multi-pair packs: a pack with qty > 1 (block Pairs, single products) repeats every option row once per pair
   ("Size · Pair 1", "Size · Pair 2"…), so sizes can mix; the price is qty × unit less the tier for that count, the
   tier rows / stepper stay off, and add sends one cart line per pair (same variants merge).
   Order-value tiers: a pack with no volume tiers (the bundles) shows the store's order-value discount
   (data-value-tiers "120:10,200:15,490:20") matched against the live cart subtotal + the pack's price, as checkout does;
   /cart.js is re-read on cart:change / cart:refresh / lp cart-add. A pack with volume tiers keeps its own percentages.
   Card badges: [data-lp-badge] with "[pct]" in data-tpl shows each pack's current saving (packPct) and hides at 0.
   Size guide: [data-lp-guide-dialog] holds the active pack's charts, the picked sizes marked. A bundle row whose option
   has a chart gets a [data-lp-guide-row] link (from [data-lp-guide-tpl]) under its pills that opens only that chart;
   the [data-lp-guide] link beside the sizes title shows only for a pack's own chart (a single product).
   Image zoom: a tap on a product photo opens [data-lp-zoom] full screen at 1800px: pinch 1–4x, one-finger pan while
   zoomed, double-tap / double-click toggles 2.5x at the point, mouse drag pans, swipe / pill / arrow keys move
   between photos; closing leaves the gallery on the last photo viewed. Pointer maths as in the s1-pdp viewer. */
(function () {
  if (customElements.get('lp-bundle-buy')) return;
  var slice = Array.prototype.slice;
  function motionOK() { return !window.LP || window.LP.motionOK !== false; }
  /* reveal el sideways inside its scrolling strip only. Element.scrollIntoView({ block: 'nearest' }) also scrolls the
     window when the strip is off screen, so calling it on init sent the whole page gliding to the thumbs (animated
     by the theme's smooth scroll-behavior) before the visitor had touched anything. */
  function revealInline(el, smooth) {
    var p = el.parentElement; if (!p) return;
    var pr = p.getBoundingClientRect(), r = el.getBoundingClientRect(), l = r.left - pr.left + p.scrollLeft, right = l + r.width, to = null;
    if (l < p.scrollLeft) to = l; else if (right > p.scrollLeft + p.clientWidth) to = right - p.clientWidth;
    if (to === null) return;
    if (p.scrollTo) p.scrollTo({ left: to, behavior: smooth ? 'smooth' : 'auto' }); else p.scrollLeft = to;
  }
  function money(cents, fmt) {
    var s = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{') >= 0) return fmt.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, s.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return '$' + s;
  }

  class LpBundleBuy extends HTMLElement {
    connectedCallback() {
      var self = this;
      try { this.data = JSON.parse(this.querySelector('[data-lp-island]').textContent); } catch (e) { this.data = []; }
      if (!this.data.length) return;
      this.fmt = this.dataset.moneyFormat || '';
      this.gsap = null; this.qty = 1; this.slide = 0; this.inView = false;
      this.track = this.querySelector('[data-lp-track]');
      this.videoSlide = this.querySelector('[data-lp-slide-video]');
      this.video = this.querySelector('[data-lp-video], .lp-bundle-buy__video');
      this.phone = window.matchMedia('(max-width: 47.99rem)');
      if (this.video && this.phone.matches) {
        if (this.video.dataset.srcMobile) this.video.dataset.src = this.video.dataset.srcMobile;
        var mp = this.video.dataset.posterMobile;
        if (mp) { this.video.poster = mp; var pi = this.querySelector('[data-lp-poster]'); if (pi) pi.src = mp; }
      }
      this.rows = this.querySelector('[data-lp-rows]');
      var ds = this.dataset;
      this.tierCfg = {
        labels: (ds.tierLabels || '').split('|').map(function (x) { return x.trim(); }),
        unit: (ds.tierUnit || 'pair|pairs').split('|'),
        /* "3: Most popular" → badge on the 3-pack */
        badge: ((ds.tierBadge || '').match(/^\s*\d+\s*:\s*(.+)$/) || [])[1] || '', badgeAt: parseInt(((ds.tierBadge || '').match(/^\s*(\d+)\s*:/) || [])[1], 10) || 0,
        def: parseInt(ds.tierDefault, 10) || 1, save: ds.saveLabel || 'Save',
        mode: ds.tierMode === 'stepper' ? 'stepper' : 'rows', hint: (ds.tierHint || '').trim()
      };
      this.valueTiers = (ds.valueTiers || '').split(',').map(function (x) { var a = x.split(':'); return { spend: Math.round(parseFloat(a[0]) * 100), pct: parseFloat(a[1]) }; })
        .filter(function (t) { return t.spend > 0 && t.pct > 0; }).sort(function (a, b) { return a.spend - b.spend; });
      this.cartSubtotal = parseInt(ds.cartSubtotal, 10) || 0;
      this.tierHint = this.querySelector('[data-lp-tier-hint]');
      this.tiersRow = this.querySelector('[data-lp-tiers-row]'); this.tiersBox = this.querySelector('[data-lp-tiers]');
      this.qtyWrap = this.querySelector('[data-lp-qty-wrap]');
      this.guideBtn = this.querySelector('[data-lp-guide]'); this.guide = this.querySelector('[data-lp-guide-dialog]'); this.guideTpl = this.querySelector('[data-lp-guide-tpl]');
      if (this.guide) { this.onGuideClick = function (e) { if (e.target === self.guide) self.guide.close(); }; this.guide.addEventListener('click', this.onGuideClick); }
      this.zoomEl = this.querySelector('[data-lp-zoom]');
      if (this.zoomEl) this.initZoom();
      this.viewer = this.querySelector('[data-lp-viewer]'); this.full = this.querySelector('[data-lp-full]');
      if (this.video) {
        this.onInlineState = function () { self.syncInline(); };
        this.video.addEventListener('play', this.onInlineState); this.video.addEventListener('pause', this.onInlineState); this.video.addEventListener('volumechange', this.onInlineState);
        this.onMeta = function () {
          if (!self.video.videoWidth) return;
          if (self.viewer) self.viewer.style.setProperty('--lp-bundle-buy-ar', self.video.videoWidth + ' / ' + self.video.videoHeight);
          /* phones: the gallery takes the clip's own ratio so the whole frame (burnt-in subtitles included) is on screen;
             desktop keeps the Gallery ratio setting */
          var g = self.querySelector('.lp-bundle-buy__gallery');
          if (g && self.phone.matches) g.style.setProperty('--lp-bundle-buy-ratio', self.video.videoWidth + ' / ' + self.video.videoHeight);
        };
        this.video.addEventListener('loadedmetadata', this.onMeta);
      }
      if (this.viewer && this.full) {
        /* the viewer sizes itself to the clip it plays (the inline clip's metadata may not have arrived yet) */
        this.onFullMeta = function () { if (self.full.videoWidth) self.viewer.style.setProperty('--lp-bundle-buy-ar', self.full.videoWidth + ' / ' + self.full.videoHeight); };
        this.full.addEventListener('loadedmetadata', this.onFullMeta);
      }
      if (this.viewer && this.full) {
        this.onTime = function () { var bar = self.querySelector('[data-lp-progress]'), seek = self.querySelector('[data-lp-seek]'); if (bar && self.full.duration) { var pc = self.full.currentTime / self.full.duration * 100; bar.style.width = pc + '%'; if (seek) seek.setAttribute('aria-valuenow', Math.round(pc)); } };
        var seekEl = this.querySelector('[data-lp-seek]');
        if (seekEl) {
          var seekTo = function (e) { var r = seekEl.getBoundingClientRect(); if (!r.width || !self.full.duration) return; var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)); self.full.currentTime = x * self.full.duration; self.onTime(); };
          seekEl.addEventListener('pointerdown', function (e) { e.preventDefault(); try { seekEl.setPointerCapture(e.pointerId); } catch (x) {} self.scrubbing = true; seekTo(e); });
          seekEl.addEventListener('pointermove', function (e) { if (self.scrubbing) seekTo(e); });
          seekEl.addEventListener('pointerup', function () { self.scrubbing = false; }); seekEl.addEventListener('pointercancel', function () { self.scrubbing = false; });
          seekEl.addEventListener('keydown', function (e) { if (!self.full.duration) return; if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); e.stopPropagation(); self.full.currentTime = Math.max(0, Math.min(self.full.duration, self.full.currentTime + (e.key === 'ArrowRight' ? 5 : -5))); self.onTime(); } });
        }
        this.onState = function () { self.viewer.classList.toggle('is-paused', self.full.paused); var t = self.querySelector('[data-lp-toggle-play]'); if (t) t.setAttribute('aria-label', self.full.paused ? 'Play' : 'Pause'); };
        this.full.addEventListener('timeupdate', this.onTime); this.full.addEventListener('play', this.onState); this.full.addEventListener('pause', this.onState);
        this.onDialogClose = function () { self.full.pause(); self.full.removeAttribute('src'); self.full.load(); document.body.style.overflow = ''; self.playVideo(); };
        this.viewer.addEventListener('close', this.onDialogClose);
        this.onKey = function (e) { if (self.viewer.open && e.key === ' ') { e.preventDefault(); if (self.full.paused) self.full.play().catch(function () {}); else self.full.pause(); } };
        document.addEventListener('keydown', this.onKey);
      }
      this.onClick = function (e) { self.click(e); };
      this.addEventListener('click', this.onClick);
      this.onTrackScroll = function () { self.gallerySync(); self.playVideo(); };
      if (this.track) this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
      this.onBlockSelect = function (e) { var b = e.target.closest && e.target.closest('[data-lp-pack]'); if (b && self.contains(b)) self.setPack(+b.dataset.lpPack); };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.packs = this.querySelector('[data-lp-packs]');
      if (this.packs) { this.onPacksScroll = function () { self.packsSync(); }; this.packs.addEventListener('scroll', this.onPacksScroll, { passive: true }); }
      this.onResize = function () { self.gallerySync(); self.packsSync(); };
      window.addEventListener('resize', this.onResize);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) { self.inView = entries.some(function (x) { return x.isIntersecting; }); self.playVideo(); }, { threshold: 0.35 });
        this.io.observe(this);
      } else { this.inView = true; }
      if (window.LP && window.LP.near) {
        this.offNear = window.LP.near(this, function () {
          if (window.LP.gsap && self.dataset.lpGsap) window.LP.gsap([self.dataset.lpGsap]).then(function (g) { self.gsap = g; });
          self.loadVideo();
        });
      } else { this.loadVideo(); }
      this.setPack(0, true);
      this.watchCart();
      this.packsSync();
    }
    /* pack strip arrows: shown while the strip can scroll, greyed at either end */
    packsSync() {
      var p = this.packs; if (!p) return;
      var can = p.scrollWidth > p.clientWidth + 4, max = p.scrollWidth - p.clientWidth;
      slice.call(this.querySelectorAll('[data-lp-packs-nav]')).forEach(function (b) {
        b.hidden = !can;
        /* the strip's resting positions sit a few px off 0 / max (padding + snap), hence the tolerance */
        b.disabled = +b.dataset.lpPacksNav < 0 ? p.scrollLeft <= 6 : p.scrollLeft >= max - 6;
      });
    }
    /* one card per tap. Chromium drops a smooth programmatic scroll inside a scroll-snap strip (it stops at the first
       snap point), so the glide is a GSAP tween with snap paused, else an instant jump to the card boundary. */
    packsStep(dir) {
      var p = this.packs; if (!p) return;
      var card = p.firstElementChild, w = card ? card.getBoundingClientRect().width + 8 : p.clientWidth;
      var target = Math.max(0, Math.min(p.scrollWidth - p.clientWidth, (Math.round(p.scrollLeft / w) + dir) * w));
      var g = this.gsap;
      if (g && motionOK()) {
        p.style.scrollSnapType = 'none';
        g.to(p, { scrollLeft: target, duration: 0.35, ease: 'power2.out', overwrite: true, onComplete: function () { p.style.scrollSnapType = ''; p.scrollTo({ left: target, behavior: 'auto' }); } });
      } else p.scrollTo({ left: target, behavior: 'auto' });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.onCart) { document.documentElement.removeEventListener('cart:change', this.onCart); document.removeEventListener('cart:refresh', this.onCart); }
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('resize', this.onResize);
      if (this.track) this.track.removeEventListener('scroll', this.onTrackScroll);
      if (this.packs) this.packs.removeEventListener('scroll', this.onPacksScroll);
      if (this.io) this.io.disconnect();
      if (this.offNear) this.offNear();
      if (this.video) { this.video.pause(); this.video.removeEventListener('play', this.onInlineState); this.video.removeEventListener('pause', this.onInlineState); this.video.removeEventListener('volumechange', this.onInlineState); this.video.removeEventListener('loadedmetadata', this.onMeta); }
      if (this.viewer) { this.viewer.removeEventListener('close', this.onDialogClose); document.removeEventListener('keydown', this.onKey); this.closeViewer(); }
      if (this.guide) { this.guide.removeEventListener('click', this.onGuideClick); if (this.guide.open) this.guide.close(); }
      if (this.onZoomKey) document.removeEventListener('keydown', this.onZoomKey);
      this.closeZoom();
    }

    /* ---------- state ---------- */
    pack() { return this.data[this.active] || this.data[0]; }
    /* pairs in a pack: block Pairs > 1 on a product with option rows */
    packQty(p) { p = p || this.pack(); return p.qty > 1 && p.options.length ? Math.round(p.qty) : 1; }
    /* option rows of the pack: a multi-pair pack repeats every option once per pair */
    rowsOf(p) {
      p = p || this.pack(); var n = this.packQty(p), out = [], unit = this.tierCfg.unit[0] || 'pair';
      if (n < 2) return p.options;
      unit = unit.charAt(0).toUpperCase() + unit.slice(1);
      for (var k = 1; k <= n; k++) p.options.forEach(function (o) { out.push(Object.assign({}, o, { label: (p.options.length > 1 ? o.label + ' \u00b7 ' : '') + unit + ' ' + k, pair: k })); });
      return out;
    }
    /* volume tiers of a pack: [{ n: 2, pct: 15 }, …] from "2:15,3:20" */
    tiers(p) {
      p = p || this.pack();
      return String(p.tiers || '').split(',').map(function (x) { var a = x.split(':'); return { n: parseInt(a[0], 10), pct: parseFloat(a[1]) }; })
        .filter(function (t) { return t.n > 1 && t.pct > 0; }).sort(function (a, b) { return a.n - b.n; });
    }
    tierCounts(p) { return [1].concat(this.tiers(p).map(function (t) { return t.n; })); }
    pctFor(q, p) { var pct = 0; this.tiers(p).forEach(function (t) { if (q >= t.n) pct = t.pct; }); return pct; }
    /* order-value %: the largest tier the projected order (cart + this pack) reaches */
    valuePct(projected) { var pct = 0; this.valueTiers.forEach(function (t) { if (projected >= t.spend) pct = t.pct; }); return pct; }
    /* a pack's saving before any size is picked: its volume tier for its pair count, else the order-value tier */
    packPct(p) {
      var n = this.packQty(p);
      if (this.tiers(p).length) return this.pctFor(n, p);
      if (!this.valueTiers.length) return 0;
      var avail = p.variants.filter(function (v) { return v.available; }), list = avail.length ? avail : p.variants;
      var unit = list.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
      return isFinite(unit) ? this.valuePct(this.cartSubtotal + unit * n) : 0;
    }
    renderBadges() {
      var self = this;
      slice.call(this.querySelectorAll('[data-lp-pack]')).forEach(function (b) {
        var bd = b.querySelector('[data-lp-badge]'); if (!bd || bd.dataset.tpl.indexOf('[pct]') < 0) return;
        var pct = self.packPct(self.data[+b.dataset.lpPack] || {});
        bd.hidden = !pct; bd.textContent = pct ? bd.dataset.tpl.replace('[pct]', pct) : '';
      });
    }
    unitPrice() { var v = this.variant(); return v ? v.price : this.minPrice(); }
    flatPrice() { var p = this.pack(); return p.variants.every(function (x) { return x.price === p.variants[0].price; }); }
    /* the variant picked for pair k (1-based), null until every row of that pair is picked */
    variantAt(k) {
      var p = this.pack(), sel = this.sel, m = p.options.length, base = (k - 1) * m;
      for (var i = 0; i < m; i++) if (!sel[base + i]) return null;
      return p.variants.filter(function (v) { return p.options.every(function (o, i) { return v.opts[o.idx] === sel[base + i]; }); })[0] || null;
    }
    variant() {
      var n = this.packQty(), first = this.variantAt(1);
      for (var k = 2; first && k <= n; k++) if (!this.variantAt(k)) return null;
      return first;
    }
    variantsAll() { var out = []; for (var k = 1; k <= this.packQty(); k++) out.push(this.variantAt(k)); return out; }
    minPrice() {
      var p = this.pack(), avail = p.variants.filter(function (v) { return v.available; });
      var list = avail.length ? avail : p.variants;
      return list.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
    }
    /* is a value pickable given the other rows' picks? (sold-out combos are slashed) */
    valueAvailable(rowIdx, value) {
      var p = this.pack(), sel = this.sel, m = p.options.length, base = Math.floor(rowIdx / m) * m, ri = rowIdx - base;
      return p.variants.some(function (v) {
        if (!v.available) return false;
        return p.options.every(function (o, i) { return i === ri ? v.opts[o.idx] === value : (!sel[base + i] || v.opts[o.idx] === sel[base + i]); });
      });
    }

    setPack(i, instant) {
      var self = this, p = this.data[i]; if (!p) return;
      this.active = i;
      var counts = this.tierCounts(p), multi = this.packQty(p);
      this.qty = multi > 1 ? multi : counts.length > 1 && this.tierCfg.mode === 'rows' ? (counts.indexOf(this.tierCfg.def) >= 0 ? this.tierCfg.def : 1) : 1;
      this.sel = this.rowsOf(p).map(function (o) { return o.def && o.values.some(function (v) { return v.name === o.def && v.available; }) ? o.def : ''; });
      slice.call(this.querySelectorAll('[data-lp-pack]')).forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.lpPack === i ? 'true' : 'false'); });
      slice.call(this.querySelectorAll('[data-lp-pack-only]')).forEach(function (n) { n.hidden = +n.dataset.lpPackOnly !== i; });
      this.buildRows();
      this.buildTiers();
      if (this.guideBtn) this.guideBtn.hidden = !this.guideChart(i, '*');
      this.open = this.sel.indexOf(''); if (this.open < 0) this.open = -1;
      this.render();
      this.setGallery(p, instant);
    }
    /* ---------- rows ---------- */
    buildRows() {
      var self = this, p = this.pack(), rows = this.rows; if (!rows) return;
      rows.innerHTML = '';
      this.rowsOf(p).forEach(function (o, i) {
        var row = document.createElement('div');
        row.className = 'lp-bundle-buy__opt'; row.dataset.lpRow = i;
        row.innerHTML =
          '<button type="button" class="lp-bundle-buy__opt-head" data-lp-toggle="' + i + '" aria-expanded="false">' +
            (o.thumb ? '<span class="lp-bundle-buy__opt-thumb"><img src="' + o.thumb + '" alt="" loading="lazy" width="80" height="80"></span>' : '') +
            '<span class="lp-bundle-buy__opt-meta"><span class="lp-bundle-buy__opt-name"></span><span class="lp-bundle-buy__opt-hint"></span></span>' +
            '<span class="lp-bundle-buy__opt-picked" data-lp-picked></span>' +
            '<span class="lp-bundle-buy__opt-chev" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span>' +
          '</button>' +
          '<div class="lp-bundle-buy__opt-body" data-lp-body hidden><div class="lp-bundle-buy__sizes" data-lp-sizes></div></div>';
        var name = row.querySelector('.lp-bundle-buy__opt-name');
        name.textContent = o.label;
        if (o.qty > 1) { var q = document.createElement('span'); q.className = 'lp-bundle-buy__opt-qty'; q.textContent = ' × ' + o.qty; name.appendChild(q); }
        var sizes = row.querySelector('[data-lp-sizes]');
        o.values.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'lp-bundle-buy__size'; b.dataset.lpSize = v.name; b.dataset.lpRowIdx = i; b.textContent = v.label;
          sizes.appendChild(b);
        });
        if (self.guideTpl && self.guideChart(self.active, o.name)) {
          var gb = self.guideTpl.content.firstElementChild.cloneNode(true);
          gb.dataset.lpGuideRow = i; gb.setAttribute('aria-label', gb.textContent.trim() + ': ' + o.label);
          row.querySelector('[data-lp-body]').appendChild(gb);
        }
        rows.appendChild(row);
      });
    }
    /* tier rows for the active pack (none when no volume discount covers it) */
    buildTiers() {
      var self = this, box = this.tiersBox, counts = this.tierCounts(), cfg = this.tierCfg;
      var multi = this.packQty() > 1, tiered = counts.length > 1 && !multi, on = tiered && !!box && cfg.mode === 'rows';
      if (this.tiersRow) this.tiersRow.hidden = !on;
      if (this.qtyWrap) this.qtyWrap.hidden = on || multi;
      /* stepper display: one saving line from the tiers ("Buy 2, save 15% · Buy 3+, save 20%") */
      if (this.tierHint) {
        var ts = this.tiers();
        this.tierHint.hidden = !(tiered && cfg.mode === 'stepper' && cfg.hint);
        this.tierHint.textContent = this.tierHint.hidden ? '' : ts.map(function (t, k) { return cfg.hint.replace('[n]', t.n + (k === ts.length - 1 ? '+' : '')).replace('[pct]', t.pct); }).join(' · ');
      }
      if (!box) return;
      box.innerHTML = '';
      if (!on) return;
      counts.forEach(function (n, i) {
        var pct = self.pctFor(n), b = document.createElement('button');
        b.type = 'button'; b.className = 'lp-bundle-buy__tier'; b.dataset.lpTier = n; b.setAttribute('role', 'radio');
        var name = cfg.labels[i] || '', unit = n + ' ' + (n === 1 ? cfg.unit[0] : (cfg.unit[1] || cfg.unit[0]));
        b.innerHTML = '<span class="lp-bundle-buy__tier-radio" aria-hidden="true"></span>' +
          '<span class="lp-bundle-buy__tier-main"><span class="lp-bundle-buy__tier-name"></span><span class="lp-bundle-buy__tier-sub"></span></span>' +
          '<span class="lp-bundle-buy__tier-price"><strong data-lp-tier-total></strong><span data-lp-tier-each></span></span>';
        b.querySelector('.lp-bundle-buy__tier-name').textContent = name || unit;
        var sub = b.querySelector('.lp-bundle-buy__tier-sub');
        sub.textContent = name ? unit : '';
        if (pct) { var sv = document.createElement('span'); sv.className = 'lp-bundle-buy__tier-save'; sv.textContent = cfg.save + ' ' + pct + '%'; sub.appendChild(sv); }
        if (cfg.badge && cfg.badgeAt === n) { var bd = document.createElement('span'); bd.className = 'lp-bundle-buy__tier-badge'; bd.textContent = cfg.badge; b.appendChild(bd); b.classList.add('has-badge'); }
        box.appendChild(b);
      });
    }
    render() {
      var self = this, p = this.pack(), v = this.variant(), fmt = this.fmt;
      var title = this.querySelector('[data-lp-title]'); if (title) { title.textContent = p.title; title.classList.toggle('is-accent', !!p.accent); }
      var price = this.querySelector('[data-lp-price]'), cmp = this.querySelector('[data-lp-compare]');
      var multi = this.packQty() > 1, tiered = this.tierCounts().length > 1 && !multi, unit = this.unitPrice();
      var pct = tiered || multi ? this.pctFor(this.qty) : 0, n = tiered || multi ? this.qty : 1;
      if (!this.tiers().length && this.valueTiers.length) pct = this.valuePct(this.cartSubtotal + unit * n);
      var shown = Math.round(unit * n * (1 - pct / 100));
      if (price) price.textContent = (v || this.flatPrice() ? '' : 'From ') + money(shown, fmt);
      if (cmp) {
        var c = pct ? unit * n : (v && v.compare > v.price ? v.compare * n : 0);
        cmp.hidden = !c; if (c) cmp.textContent = money(c, fmt);
      }
      if (tiered && this.tiersBox) {
        slice.call(this.tiersBox.querySelectorAll('[data-lp-tier]')).forEach(function (b) {
          var k = +b.dataset.lpTier, kp = self.pctFor(k), tot = Math.round(unit * k * (1 - kp / 100));
          b.setAttribute('aria-checked', k === self.qty ? 'true' : 'false');
          b.querySelector('[data-lp-tier-total]').textContent = money(tot, fmt);
          var each = b.querySelector('[data-lp-tier-each]');
          each.textContent = k > 1 ? money(Math.round(tot / k), fmt) + ' / ' + self.tierCfg.unit[0] : '';
        });
      }
      var anyStock = p.variants.some(function (x) { return x.available; }), rowsOf = this.rowsOf(p);
      var inStock = !!v && this.variantsAll().every(function (x) { return x && x.available; });
      slice.call(this.rows.querySelectorAll('[data-lp-row]')).forEach(function (row, i) {
        var o = rowsOf[i], picked = self.sel[i], isOpen = self.open === i;
        var head = row.querySelector('[data-lp-toggle]'), body = row.querySelector('[data-lp-body]');
        row.classList.toggle('is-open', isOpen); row.classList.toggle('is-sized', !!picked);
        head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        var chip = row.querySelector('[data-lp-picked]');
        var val = picked ? o.values.filter(function (x) { return x.name === picked; })[0] : null;
        chip.textContent = val ? val.label : self.dataset.pickLabel;
        chip.classList.toggle('is-set', !!val);
        row.querySelector('.lp-bundle-buy__opt-hint').textContent = val && !isOpen ? self.dataset.changeLabel : '';
        slice.call(row.querySelectorAll('[data-lp-size]')).forEach(function (b) {
          var ok = self.valueAvailable(i, b.dataset.lpSize);
          b.setAttribute('aria-pressed', b.dataset.lpSize === picked ? 'true' : 'false');
          b.toggleAttribute('data-sold-out', !ok);
          b.setAttribute('aria-label', b.dataset.lpSize + (ok ? '' : ', sold out'));
        });
        self.fold(body, isOpen);
      });
      var q = this.querySelector('[data-lp-qty-value]'); if (q) q.value = this.qty;
      var atc = this.querySelector('[data-lp-atc]'), label = this.querySelector('[data-lp-atc-label]');
      if (!anyStock) { label.textContent = atc.dataset.soldOut; atc.disabled = true; }
      else if (!v) { label.textContent = this.dataset.sizePrompt; atc.disabled = false; }
      else { label.textContent = inStock ? atc.dataset.label : atc.dataset.soldOut; atc.disabled = !inStock; }
      var sum = this.querySelector('[data-lp-summary]');
      if (sum) {
        var parts = rowsOf.map(function (o, i) { var x = self.sel[i] ? o.values.filter(function (y) { return y.name === self.sel[i]; })[0] : null; return x ? o.label + ' ' + x.label : null; }).filter(Boolean);
        if (tiered && parts.length) parts.push(this.qty + ' ' + (this.qty === 1 ? this.tierCfg.unit[0] : (this.tierCfg.unit[1] || this.tierCfg.unit[0])));
        sum.textContent = parts.join(' · ');
      }
      var err = this.querySelector('[data-lp-error]'); if (err) err.hidden = true;
      this.renderBadges();
    }
    fold(body, open) {
      var g = this.gsap;
      if (!g || !motionOK() || body.hidden === !open && !body.dataset.animating) { body.hidden = !open; if (!open) body.style.height = ''; return; }
      if (open) { body.hidden = false; g.fromTo(body, { height: 0, autoAlpha: 0 }, { height: 'auto', autoAlpha: 1, duration: 0.35, ease: 'power2.out', clearProps: 'height,opacity,visibility' }); }
      else { g.to(body, { height: 0, autoAlpha: 0, duration: 0.25, ease: 'power2.in', onComplete: function () { body.hidden = true; body.style.height = ''; body.style.opacity = ''; body.style.visibility = ''; } }); }
    }

    /* ---------- events ---------- */
    click(e) {
      var t = e.target;
      var pack = t.closest('[data-lp-pack]'); if (pack && this.contains(pack)) { this.setPack(+pack.dataset.lpPack); return; }
      var tog = t.closest('[data-lp-toggle]'); if (tog) { var i = +tog.dataset.lpToggle; this.open = this.open === i ? -1 : i; this.render(); return; }
      var size = t.closest('[data-lp-size]');
      if (size) {
        var r = +size.dataset.lpRowIdx, val = size.dataset.lpSize;
        this.sel[r] = this.sel[r] === val ? '' : val;
        if (this.sel[r]) { var next = -1; for (var k = 0; k < this.sel.length; k++) { var j = (r + 1 + k) % this.sel.length; if (!this.sel[j]) { next = j; break; } } this.open = next; }
        this.render(); return;
      }
      var tier = t.closest('[data-lp-tier]'); if (tier) { this.qty = +tier.dataset.lpTier; this.render(); return; }
      var gr = t.closest('[data-lp-guide-row]'); if (gr) { this.openGuide(+gr.dataset.lpGuideRow); return; }
      if (t.closest('[data-lp-guide]')) { this.openGuide(); return; }
      var qty = t.closest('[data-lp-qty]'); if (qty) { this.qty = Math.max(1, Math.min(10, this.qty + (+qty.dataset.lpQty))); this.render(); return; }
      if (t.closest('[data-lp-atc]')) { this.add(); return; }
      var pn = t.closest('[data-lp-packs-nav]'); if (pn) { this.packsStep(+pn.dataset.lpPacksNav); return; }
      var nav = t.closest('[data-lp-nav]'); if (nav) { this.galleryStep(+nav.dataset.lpNav); return; }
      var th = t.closest('[data-lp-thumb]'); if (th) { this.galleryTo(+th.dataset.lpThumb); return; }
      if (t.closest('[data-lp-zoom-close]')) { this.closeZoom(); return; }
      var zs = t.closest('[data-lp-zoom-step]'); if (zs) { this.zoomShow(this.zi + (+zs.dataset.lpZoomStep)); return; }
      if (this.zoomEl && t === this.zoomEl) { this.closeZoom(); return; }
      var slideImg = t.closest('[data-lp-slide-img]');
      if (slideImg && this.track && this.track.contains(slideImg)) { this.openZoom(slice.call(this.track.querySelectorAll('[data-lp-slide-img]')).indexOf(slideImg)); return; }
      if (t.closest('[data-lp-close]')) { this.closeViewer(); return; }
      if (t.closest('[data-lp-mute]')) { this.full.muted = !this.full.muted; var m = this.querySelector('[data-lp-mute]'); m.setAttribute('aria-pressed', this.full.muted ? 'true' : 'false'); return; }
      if (t.closest('[data-lp-toggle-play]')) { if (this.full.paused) this.full.play().catch(function () {}); else this.full.pause(); return; }
      if (this.viewer && t === this.viewer) { this.closeViewer(); return; }
      if (t.closest('[data-lp-expand]')) { this.openViewer(); return; }
      if (t.closest('[data-lp-inline-mute]')) { this.video.muted = !this.video.muted; if (!this.video.muted) { this.userPaused = false; var p2 = this.video.play(); if (p2 && p2.catch) p2.catch(function () {}); if (window.LP) window.LP.emit('sound', { source: this }); } return; }
      if (t.closest('[data-lp-inline-toggle]') || t.closest('[data-lp-clip]')) { if (this.video.paused) { this.userPaused = false; var p3 = this.video.play(); if (p3 && p3.catch) p3.catch(function () {}); } else { this.userPaused = true; this.video.pause(); } return; }
    }
    syncInline() {
      var v = this.video; if (!v || !this.videoSlide) return;
      this.videoSlide.classList.toggle('is-paused', v.paused);
      var tg = this.querySelector('[data-lp-inline-toggle]'); if (tg) tg.setAttribute('aria-label', v.paused ? 'Play' : 'Pause');
      var m = this.querySelector('[data-lp-inline-mute]'); if (m) { m.setAttribute('aria-pressed', v.muted ? 'true' : 'false'); m.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute'); }
    }

    /* ---------- image zoom ---------- */
    initZoom() {
      var self = this, zm = this.zoomEl, vp = zm.querySelector('[data-lp-zoom-viewport]'), img = zm.querySelector('[data-lp-zoom-img]');
      if (!vp || !img) return;
      this.zImg = img; this.zi = 0;
      var MIN = 1, MAX = 4, DBL = 2.5, z = { scale: 1, x: 0, y: 0 };
      var start = null, lastTap = 0, swipeX = null, drag = null;
      var clamp = function () {
        var r = vp.getBoundingClientRect(), mx = r.width * (z.scale - 1) / 2, my = r.height * (z.scale - 1) / 2;
        z.x = Math.max(-mx, Math.min(mx, z.x)); z.y = Math.max(-my, Math.min(my, z.y));
      };
      this.zApply = function (anim) {
        img.style.transition = anim && motionOK() ? 'transform .25s ease' : 'none';
        img.style.transform = z.scale === 1 ? '' : 'translate(' + z.x + 'px, ' + z.y + 'px) scale(' + z.scale + ')';
        zm.classList.toggle('is-zoomed', z.scale > 1);
      };
      this.zReset = function () { z.scale = 1; z.x = 0; z.y = 0; self.zApply(false); };
      /* zoom about a viewport point so the pixel under the fingers stays put */
      var zoomAt = function (next, px, py) {
        var r = vp.getBoundingClientRect(), cx = px - r.left - r.width / 2, cy = py - r.top - r.height / 2, k = next / z.scale;
        z.x = cx - (cx - z.x) * k; z.y = cy - (cy - z.y) * k; z.scale = next; clamp();
      };
      var dist = function (t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); };
      var mid = function (t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; };
      vp.addEventListener('touchstart', function (e) {
        var t = e.touches;
        if (t.length === 2) { start = { d: dist(t), scale: z.scale, m: mid(t) }; swipeX = null; }
        else if (t.length === 1) { start = { one: true, px: t[0].clientX, py: t[0].clientY, x: z.x, y: z.y }; swipeX = z.scale === 1 ? t[0].clientX : null; }
      }, { passive: true });
      vp.addEventListener('touchmove', function (e) {
        var t = e.touches; if (!start) return;
        if (t.length === 2 && start.d) {
          e.preventDefault();
          var m = mid(t), next = Math.max(MIN, Math.min(MAX, start.scale * (dist(t) / start.d)));
          zoomAt(next, start.m.x, start.m.y);
          z.x += m.x - start.m.x; z.y += m.y - start.m.y;
          start.m = m; start.scale = next; start.d = dist(t);
          clamp(); self.zApply(false);
        } else if (t.length === 1 && start.one && z.scale > 1) {
          e.preventDefault();
          z.x = start.x + (t[0].clientX - start.px); z.y = start.y + (t[0].clientY - start.py);
          clamp(); self.zApply(false);
        }
      }, { passive: false });
      vp.addEventListener('touchend', function (e) {
        if (e.touches.length) { start = null; return; }
        var ch = e.changedTouches[0];
        if (z.scale <= MIN + 0.05) { z.scale = 1; z.x = 0; z.y = 0; self.zApply(true); }
        if (start && start.one && ch) {
          var moved = Math.hypot(ch.clientX - start.px, ch.clientY - start.py), now = Date.now();
          if (moved < 12) {
            if (now - lastTap < 300) {
              if (z.scale > 1) { z.scale = 1; z.x = 0; z.y = 0; } else zoomAt(DBL, ch.clientX, ch.clientY);
              self.zApply(true); lastTap = 0;
            } else lastTap = now;
          } else if (swipeX !== null && z.scale === 1) {
            var dx = ch.clientX - swipeX;
            if (dx < -50) self.zoomShow(self.zi + 1); else if (dx > 50) self.zoomShow(self.zi - 1);
          }
        }
        start = null; swipeX = null;
      });
      /* mouse: double-click toggles 2.5x at the point, drag pans while zoomed */
      vp.addEventListener('dblclick', function (e) { if (z.scale > 1) { z.scale = 1; z.x = 0; z.y = 0; } else zoomAt(DBL, e.clientX, e.clientY); self.zApply(true); });
      vp.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || z.scale === 1) return; drag = { px: e.clientX, py: e.clientY, x: z.x, y: z.y }; try { vp.setPointerCapture(e.pointerId); } catch (x) {} });
      vp.addEventListener('pointermove', function (e) { if (!drag) return; z.x = drag.x + (e.clientX - drag.px); z.y = drag.y + (e.clientY - drag.py); clamp(); self.zApply(false); });
      var endDrag = function () { drag = null; };
      vp.addEventListener('pointerup', endDrag); vp.addEventListener('pointercancel', endDrag);
      /* after closing (button, backdrop or Escape): unlock the page, leave the gallery on the photo last viewed.
         Run directly by closeZoom and again by the close event; the second run finds nothing to do. */
      this.afterZoom = function () {
        if (!self.zoomOpen) return;
        self.zoomOpen = false;
        document.body.style.overflow = '';
        self.zReset();
        var t = self.track, i = (self.videoSlide ? 1 : 0) + self.zi;
        if (t && t.children[i]) { self.slide = i; t.scrollTo({ left: i * t.clientWidth, behavior: 'auto' }); self.gallerySync(); self.playVideo(); }
      };
      zm.addEventListener('close', this.afterZoom);
      this.onZoomKey = function (e) { if (!zm.open) return; if (e.key === 'ArrowRight') self.zoomShow(self.zi + 1); else if (e.key === 'ArrowLeft') self.zoomShow(self.zi - 1); };
      document.addEventListener('keydown', this.onZoomKey);
    }
    zoomList() { var p = this.pack(); return (p.zoom && p.zoom.length ? p.zoom : p.images) || []; }
    openZoom(i) {
      var zm = this.zoomEl; if (!zm || !zm.showModal || i < 0) return;
      this.zoomShow(i);
      if (this.video && !this.video.paused) this.video.pause();
      document.body.style.overflow = 'hidden';
      zm.showModal();
      this.zoomOpen = true;
    }
    zoomShow(i) {
      var list = this.zoomList(), n = list.length, zm = this.zoomEl; if (!n || !zm) return;
      i = (i + n) % n; this.zi = i;
      if (this.zReset) this.zReset();
      var p = this.pack();
      this.zImg.src = list[i]; this.zImg.alt = p.title + ' ' + (i + 1) + ' of ' + n;
      var cur = zm.querySelector('[data-lp-zoom-current]'), tot = zm.querySelector('[data-lp-zoom-total]');
      if (cur) cur.textContent = i + 1; if (tot) tot.textContent = n;
      slice.call(zm.querySelectorAll('[data-lp-zoom-step]')).forEach(function (b) { b.hidden = n < 2; });
    }
    closeZoom() { if (this.zoomEl && this.zoomEl.open) this.zoomEl.close(); if (this.afterZoom) this.afterZoom(); }

    /* ---------- size guide ---------- */
    /* the active pack's chart for an option name ('*' = the pack's own chart), or null */
    guideChart(i, name) {
      if (!this.guide) return null;
      return slice.call(this.guide.querySelectorAll('[data-lp-guide-pack="' + i + '"] [data-lp-guide-option]')).filter(function (c) {
        return c.dataset.lpGuideOption === name && c.querySelector('.lp-size-chart');
      })[0] || null;
    }
    /* row: a size row index shows only that component's chart; none shows all of the pack's */
    openGuide(row) {
      var g = this.guide; if (!g || !g.showModal) return;
      var self = this, p = this.pack(), i = this.active, only = typeof row === 'number' && p.options[row] ? p.options[row].name : null;
      slice.call(g.querySelectorAll('[data-lp-guide-pack]')).forEach(function (n) { n.hidden = +n.dataset.lpGuidePack !== i; });
      /* mark the picked size in each chart: the chart's row for that option (or every row for a single product) */
      slice.call(g.querySelectorAll('[data-lp-guide-pack="' + i + '"] [data-lp-guide-option]')).forEach(function (c) {
        var on = c.dataset.lpGuideOption, idx = -1;
        c.hidden = !!only && on !== only;
        p.options.forEach(function (o, k) { if (on === '*' ? idx < 0 : o.name === on) idx = k; });
        var picked = idx >= 0 ? self.sel[idx] : '', val = idx >= 0 && picked ? p.options[idx].values.filter(function (x) { return x.name === picked; })[0] : null;
        slice.call(c.querySelectorAll('tr[data-size]')).forEach(function (tr) {
          var sz = tr.dataset.size; tr.classList.toggle('is-current', !!val && (sz === val.name || sz === val.label));
        });
      });
      g.showModal();
    }

    /* ---------- viewer (full screen, with sound) ---------- */
    openViewer() {
      if (!this.viewer || !this.viewer.showModal || !this.video) return;
      this.video.pause();
      this.full.src = this.video.dataset.src; this.full.poster = this.video.poster || ''; this.full.muted = false; this.full.currentTime = this.video.currentTime || 0;
      var m = this.querySelector('[data-lp-mute]'); if (m) m.setAttribute('aria-pressed', 'false');
      document.body.style.overflow = 'hidden';
      this.viewer.showModal();
      var pr = this.full.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    closeViewer() { if (this.viewer && this.viewer.open) this.viewer.close(); }

    /* ---------- gallery ---------- */
    setGallery(p, instant) {
      var self = this, track = this.track; if (!track) return;
      slice.call(track.querySelectorAll('[data-lp-slide-img]')).forEach(function (n) { n.remove(); });
      (p.images || []).forEach(function (src, i) {
        var d = document.createElement('div'); d.className = 'lp-bundle-buy__slide'; d.setAttribute('data-lp-slide-img', '');
        var im = document.createElement('img'); im.className = 'lp-bundle-buy__img'; im.src = src; im.alt = ''; im.width = 1000; im.height = 1000; im.loading = i ? 'lazy' : 'eager';
        d.appendChild(im); track.appendChild(d);
      });
      var n = track.children.length;
      var thumbs = this.querySelector('[data-lp-thumbs]');
      if (thumbs) {
        thumbs.innerHTML = '';
        var srcs = [];
        if (this.videoSlide) { var gd = this.querySelector('[data-lp-gallery]').dataset; srcs.push({ src: (this.phone.matches && gd.videoThumbMobile) || gd.videoThumb || '', video: true }); }
        (p.images || []).forEach(function (src) { srcs.push({ src: src }); });
        srcs.forEach(function (t, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'lp-bundle-buy__thumb' + (t.video ? ' lp-bundle-buy__thumb--video' : ''); b.dataset.lpThumb = i; b.tabIndex = -1;
          if (t.src) { var im = document.createElement('img'); im.src = t.src; im.alt = ''; im.width = 96; im.height = 96; im.loading = 'lazy'; b.appendChild(im); }
          thumbs.appendChild(b);
        });
        thumbs.hidden = n < 2;
      }
      slice.call(this.querySelectorAll('[data-lp-nav]')).forEach(function (b) { b.hidden = n < 2; });
      var bar = this.querySelector('.lp-bundle-buy__gallery-bar'); if (bar) bar.hidden = n < 2;
      if (!instant) { this.slide = 0; track.scrollTo({ left: 0, behavior: 'auto' }); }
      this.gallerySync();
    }
    gallerySync() {
      var track = this.track, n = track ? track.children.length : 0, bar = this.querySelector('[data-lp-gallery-bar]');
      if (track && n && track.clientWidth) this.slide = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / track.clientWidth)));
      if (bar && n) { bar.style.width = (100 / n) + '%'; bar.style.transform = 'translateX(' + (this.slide * 100) + '%)'; }
      var cur = this.slide;
      slice.call(this.querySelectorAll('[data-lp-thumb]')).forEach(function (t) { var on = +t.dataset.lpThumb === cur; t.setAttribute('aria-current', on ? 'true' : 'false'); if (on) revealInline(t); });
    }
    galleryTo(i) {
      var track = this.track; if (!track) return;
      this.slide = i;
      track.scrollTo({ left: i * track.clientWidth, behavior: motionOK() ? 'smooth' : 'auto' });
      this.gallerySync(); this.playVideo();
    }
    galleryStep(dir) {
      var track = this.track; if (!track || track.children.length < 2) return;
      var n = track.children.length, i = (this.slide + dir + n) % n;
      this.slide = i;
      track.scrollTo({ left: i * track.clientWidth, behavior: motionOK() ? 'smooth' : 'auto' });
      var bar = this.querySelector('[data-lp-gallery-bar]'); if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
      this.playVideo();
    }

    /* ---------- video ---------- */
    loadVideo() {
      var v = this.video; if (!v || v.src || !v.dataset.src) return;
      v.src = v.dataset.src; v.load();
      this.playVideo();
    }
    playVideo() {
      var v = this.video; if (!v || !v.src) return;
      var onSlide = this.slide === 0 && this.inView && motionOK();
      if (onSlide && !this.userPaused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else if (!onSlide) { v.pause(); if (!v.muted) v.muted = true; }
    }

    /* ---------- cart ---------- */
    add() {
      var self = this, v = this.variant(), btn = this.querySelector('[data-lp-atc]'), err = this.querySelector('[data-lp-error]');
      if (!v) {
        var i = this.sel.indexOf(''); if (i >= 0) { this.open = i; this.render(); }
        var s = this.rows.querySelector('[data-lp-row="' + i + '"]'); if (s) { s.classList.remove('is-shake'); void s.offsetWidth; s.classList.add('is-shake'); }
        return;
      }
      var all = this.variantsAll(), items = [], byId = {};
      if (all.some(function (x) { return !x || !x.available; }) || btn.getAttribute('aria-busy') === 'true') return;
      /* one line per pair; the same variant picked twice merges into one line */
      all.forEach(function (x) { if (byId[x.id]) byId[x.id].quantity += 1; else { byId[x.id] = { id: x.id, quantity: 1 }; items.push(byId[x.id]); } });
      if (this.packQty() < 2) items = [{ id: v.id, quantity: this.qty }];
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      btn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: root + 'variants/' + v.id }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          btn.removeAttribute('aria-busy');
          if (!res.ok) { err.hidden = false; err.textContent = (res.json && res.json.description) || 'Could not add to cart. Please try again.'; return; }
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = res.json.sections;
            if (!cart.sections) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            self.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.json.items || [res.json], cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            if (window.LP) window.LP.emit('cart-add', { items: items, cart: cart, source: 'lp-bundle-buy', handle: self.pack().handle });
          });
        })
        .catch(function () { btn.removeAttribute('aria-busy'); err.hidden = false; err.textContent = 'Could not add to cart. Please try again.'; });
    }
  }
  customElements.define('lp-bundle-buy', LpBundleBuy);
})();
